export default class CountryResources {
    constructor(CountryResources) {
        this.CountryResources = CountryResources;
        this.countryParam = 'country';
        this.selector = {
            select: '.js-country-select',
            pesticideList: '.pesticide__list',
            redListButton: '#redList-popup .modal__footer .btn',
        };
        this.regexPattern = new RegExp('\\?[A-Za-z]');
        this.list = this.CountryResources.querySelector(this.selector.select);
        this.init();
    }

    init() {
        this.list.addEventListener('input', this.handleUrlChange.bind(this));

        const pesticideListElements = document.querySelectorAll(this.selector.pesticideList);

        pesticideListElements.forEach(element => {
            element.addEventListener('click', this.handlePestClick.bind(this));
        });

        this.redListButton = document.querySelector(this.selector.redListButton);
    }

    handlePestClick(event) {
        const url = event.currentTarget.href;

        if (this.redListButton) {
            this.redListButton.href = url;
        }
    }

    handleUrlChange(event) {
        const countryOption = event.currentTarget.value.toLowerCase();
        const {href} = location;
        const {getUrlParameter, removeUrlParam} = UX.utils;
        const isItCountry = getUrlParameter(this.countryParam);
        let link = href;
        if (isItCountry) {
            link = removeUrlParam(this.countryParam, href);
        }
        if (this.regexPattern.test(link)) {
            link = `${link}&${this.countryParam}=${countryOption}`;
        } else {
            link = `${link}${~link.indexOf('?') ? '' : '?'}${this.countryParam}=${countryOption}`;
        }
        location.href = link;
    }
}
